import React from 'react';
import { IconSvgProps } from '@models/common';

const Ask: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.07204 2.00586C5.06329 2.14194 2.66577 4.62431 2.66577 7.66665C2.66577 8.29998 2.76966 8.90904 2.96135 9.47772C3.03348 9.69173 3.06955 9.79873 3.07605 9.88094C3.08247 9.96212 3.07762 10.019 3.05753 10.0979C3.0372 10.1779 2.9923 10.261 2.90249 10.4272L1.81206 12.4456C1.65652 12.7334 1.57875 12.8774 1.59615 12.9885C1.61131 13.0853 1.66826 13.1705 1.75188 13.2215C1.84788 13.28 2.01063 13.2632 2.33613 13.2296L5.75014 12.8767C5.85353 12.866 5.90522 12.8606 5.95234 12.8624C5.99868 12.8642 6.0314 12.8686 6.07659 12.879C6.12253 12.8896 6.18031 12.9118 6.29587 12.9563C6.9279 13.1998 7.61458 13.3333 8.33243 13.3333C10.2227 13.3333 11.8968 12.4078 12.9262 10.9852M10.4781 2.4203C10.6568 2.49347 10.831 2.57551 11 2.66587C11.1135 2.72652 11.2246 2.79093 11.3333 2.85892C11.8008 3.1513 12.2225 3.50996 12.5854 3.92173M13.75 6C13.8167 6.21696 13.8707 6.43946 13.9111 6.66665C13.9689 6.99126 13.9991 7.32543 13.9991 7.66665C13.9991 7.97259 13.9749 8.27287 13.9282 8.56567C13.9168 8.63718 13.904 8.70825 13.89 8.77885M7.0304 5.89329C7.14787 5.55937 7.37972 5.2778 7.68489 5.09845C7.99007 4.9191 8.34887 4.85353 8.69775 4.91338C9.04663 4.97322 9.36307 5.1546 9.59103 5.4254C9.81899 5.6962 9.94376 6.03894 9.94323 6.39292C9.94323 7.39217 8.44435 7.8918 8.44435 7.8918V8.45746M8.46367 10.4272V10.3866'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Ask;
